export const LOGO_SOFTOURING= "/images/logo.svg";
export const LOGO_DARK= "/images/logo_dark.svg";
export const LOGO_POW= "/images/logo_pow_dark_bg.png";
export const LOGIN_IMAGE = "/images/login.png";
